export default __webpack_public_path__ + "static/media/features_auto_repair.a75e6bba.png";